import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Message } from 'slovlex-idsk-react-components';
import { Heading } from 'idsk-react-components';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import routes from '../../../../routing/routes';
import useFieldErrorMessages from '../../../useFieldErrorMessages';
import { updateTerminPreviazaneTerminy } from '../../../../client/termin/terminPreviazaneTerminyUpdateClient';
import PreviazanyTermin from '../../../../model/PreviazanyTermin';
import PreviazaneTerminyUpdateForm from './component/PreviazaneTerminyUpdateForm';
import PreviazanyTerminDetail from '../../../../model/PreviazanyTerminDetail';
import { technickePricinyErrorStatus } from '../../../../constants/ErrorConstant';

interface Props {
  initialPreviazaneTerminy: Array<PreviazanyTermin>;
  initialPreviazaneTerminyDetail: Array<PreviazanyTerminDetail>;
}

const PreviazaneTerminyUpdate = ({ initialPreviazaneTerminy, initialPreviazaneTerminyDetail }: Props): ReactElement => {
  const [previazaneTerminy, setPreviazaneTerminy] = useState(initialPreviazaneTerminy);
  const { tezaurusUuid, terminUuid } = useParams<{ tezaurusUuid: string, terminUuid: string }>();

  const {
    wrapClient: terminPreviazaneTerminyUpdateClient,
    status: updateTerminStatus,
  } = useClient(updateTerminPreviazaneTerminy);

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const { handleStatus } = useClientStatusContext();
  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
    clearAllFieldErrorMessages,
  } = useFieldErrorMessages();

  const handleSubmit = async (event): Promise<void> => {
    event.preventDefault();
    setPreviazaneTerminy(previazaneTerminy);
    try {
      await terminPreviazaneTerminyUpdateClient(terminUuid, previazaneTerminy.map(termin => ({
        ...termin,
        vztah: termin.vztah === '' ? undefined : termin.vztah,
      })));
      navigate(routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid));
      displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
    } catch (e) { /**/ }
  };

  useEffect(() => {
    if (updateTerminStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [updateTerminStatus, handleStatus]);

  return (
    <>
      {getFieldErrorMessage('previazanyTerminUpdateRequestList') && (
      <Message
        className="client-error-message"
        key={updateTerminStatus.responseCode}
        type="error"
        onClear={() => clearFieldErrorMessage('previazanyTerminUpdateRequestList')}
      >
        <Heading
          className="client-error-message__heading"
          size="m"
        >
          {getFieldErrorMessage('previazanyTerminUpdateRequestList')}
        </Heading>
      </Message>
      )}
      <PreviazaneTerminyUpdateForm
        previazaneTerminy={previazaneTerminy}
        initialPreviazaneTerminyDetail={initialPreviazaneTerminyDetail}
        setPreviazaneTerminy={setPreviazaneTerminy}
        onSubmit={handleSubmit}
        getFieldErrorMessage={getFieldErrorMessage}
        clearFieldErrorMessage={clearFieldErrorMessage}
        clearAllFieldErrorMessages={clearAllFieldErrorMessages}
        loading={updateTerminStatus.loading}
      />
    </>
  );
};

export default PreviazaneTerminyUpdate;
